import api from '../utils/axios';

export const submitSpecialOffer = payload => api.post('/special-offer', payload);
export const getSpecialOfferLeads = params => api.get('/special-offer', { params });
export const retrySpecialOfferLead = (id, target) => api.post(`/special-offer/${id}/retry`, { target });
export const getSpecialOfferCampaign = () => api.get('/special-offer/campaign');
export const getAdminSpecialOfferCampaign = () => api.get('/special-offer/campaign/admin');
export const saveSpecialOfferSettings = settings => api.patch('/special-offer/campaign/settings', settings);
export const createSpecialOfferMachine = data => api.post('/special-offer/campaign/machines', data);
export const updateSpecialOfferMachine = (id, data) => api.patch(`/special-offer/campaign/machines/${id}`, data);
export const deleteSpecialOfferMachine = id => api.delete(`/special-offer/campaign/machines/${id}`);
export const uploadSpecialOfferImage = file => {
  const data = new FormData();
  data.append('image', file);
  return api.post('/special-offer/campaign/upload', data);
};
